import React, { useState, useEffect } from "react";
import { phpPath } from "./config";
import ImageUploader from "./ImageUploader";

const ProductManager = () => {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [stock, setStock] = useState("");
  const [description, setDescription] = useState("");
  const [mainImage, setMainImage] = useState(null);
  const [extraImages, setExtraImages] = useState([]);
  const [status, setStatus] = useState("");
  const [imageUrls, setImageUrls] = useState(null);

  const handleUpload = async (e) => {
    e.preventDefault(); // prevent accidental form reload
    try {
      if (!mainImage) {
        setStatus("❌ Please select a main image.");
        return;
      }

      setStatus("Uploading images...");

      // Prepare FormData for image upload
      const formData = new FormData();
      formData.append("mainImage", mainImage);
      extraImages.forEach((img, i) => {
        formData.append("extraImages[]", img);
      });

      // Upload images
      const uploadRes = await fetch(`${phpPath}/upload_images.php`, {
        method: "POST",
        body: formData,
      });

      const uploadData = await uploadRes.json();

      if (!uploadData.success) {
        throw new Error("Image upload failed.");
      }

      // ✅ Console log the uploaded image URLs
      console.log("Main Image URL:", uploadData.mainImagePath);
      console.log("Extra Images URLs:", uploadData.extraImagePaths);

      // Prepare payload for product insertion
      const payload = new URLSearchParams({
        name,
        price,
        stock,
        description,
        mainImage: uploadData.mainImagePath,
        images: JSON.stringify(uploadData.extraImagePaths), // send as stringified array
      });

      // Insert product into DB
      const productRes = await fetch(`${phpPath}/add_product.php`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload,
      });

      const productData = await productRes.json();

      if (productData.success) {
        setStatus("✅ Product added successfully!");
        // Reset form
        setName("");
        setPrice("");
        setStock("");
        setDescription("");
        setMainImage(null);
        setExtraImages([]);
      } else {
        throw new Error("Failed to insert product into DB.");
      }
    } catch (err) {
      console.error(err);
      setStatus("❌ Error: " + err.message);
    }
  };


  useEffect(() => {
    console.log("Image URLs:", imageUrls);
  }, [imageUrls]);
    //   jsx
  return (
    <div className="admin-uploader">
      <h2>Add New Product 🛒</h2>

      <input
        type="text"
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        type="number"
        placeholder="Price"
        value={price}
        onChange={(e) => setPrice(e.target.value)}
      />
      <input
        type="number"
        placeholder="Stock"
        value={stock}
        onChange={(e) => setStock(e.target.value)}
      />
      <textarea
        placeholder="Description (HTML allowed)"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      

      <button onClick={handleUpload}>Upload Product</button>

      <p>{status}</p>


      <ImageUploader setImageUrls={setImageUrls} />
    </div>
  );
};

export default ProductManager;